import { useState } from "react";
import TasksProcessingSvg from "../../content/img/tasksProcessing.svg";
import moment from "moment";
import { Button } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const TasksProcessing = ({ onCloseClick, onRefreshStatus }) => {
  const { t } = useTranslation(["RolloverTasksModal"]);
  const [updateTime, setUpdateTime] = useState(null);

  const refreshStatus = () => {
    onRefreshStatus();
    setUpdateTime(new Date());
  };

  return (
    <div className="d-flex justify-content-center align-items-center flex-column space-y-6 h-100 pb-5">
      <div>
        <p className="text-center fw-bold">{t("ProcessingDataTitle")}</p>
      </div>
      <div>
        <img src={TasksProcessingSvg} height={145} />
      </div>
      <div>
        <p className="text-center">{t("ProcessingText1")}</p>
        <p className="text-center">{t("ProcessingText2")}</p>
      </div>
      <div>
        <button
          className="btn btn-link text-decoration-none experttax-blue"
          onClick={onCloseClick}
        >
          {t("ButtonText")}
        </button>
        {onRefreshStatus && (
          <>
            <Button
              className="mt-4 btn btn-primary"
              iconCss="fa-regular fa-arrows-rotate"
              text={t("RefreshButtonText")}
              onClick={refreshStatus}
            />
            {updateTime && (
              <div className="mt-3 text-center et-darkest-gray fw-semibold">
                <p>
                  {t("LastUpdatedText")}
                  {moment(updateTime).format("hh:mm a")}.
                </p>
                <p>{t("RefreshForLastStatusText")}</p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
